import { Link, Route, Routes } from "react-router-dom";
import { Layout, Typography, Space } from "antd";
import Navbar from "./components/Navbar";
import "./App.css";
import Homepage from "./components/Homepage";
import Exchanges from "./components/Exchanges";
import Cryptocurrencies from "./components/Cryptocurrencies";
import CryptoDetails from "./components/CryptoDetails";
import News from "./components/News";

function App() {
  return (
    <div className="app">
     <div className="navbar" >
      <Navbar />
     </div>
     <div className="main" >
      <div className="routes">
        <Routes>
          <Route exact path="/" element={<Homepage />} />
            
          
          <Route exact path="/exchanges" element={<Exchanges />} />
           
        
          <Route exact path="/cryptocurrencies" element={<Cryptocurrencies />} />
            
        
          <Route exact path="/crypto/:coinId" element={ <CryptoDetails />} />
           
          
          <Route exact path="/news" element={<News />} />
            
          
        </Routes>
      </div>
     
     <div className="footer" >
      <Typography.Title level={5} style={{color: 'white'}}>
        Cryptoverse <br />
        All rights reserved
      </Typography.Title>
      <Space>
        <Link to="/">Home</Link>
        <Link to="/exchanges">Exchanges</Link>
        <Link to="/news">News</Link>
      </Space>
     </div>
     </div>
    </div>
  );
}

export default App;
